import * as React from 'react';

import { useGetAirports } from '../api/hooks/common';
import { AirportInfo } from '../api/clients';

const AirportInfoContext = React.createContext<AirportInfo[] | undefined>(undefined!);

export function AirportInfoProvider({ children }: { children: React.ReactNode }) {
  const { data: airportInfo } = useGetAirports();

  return (
    <AirportInfoContext.Provider value={airportInfo}>
      {children}
    </AirportInfoContext.Provider>
  );
}

export const useAirportInfo = () => React.useContext(AirportInfoContext);
